var _circle, _rect, _rect2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _path, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 18.5,
    width: 47,
    height: 32.2308,
    stroke: "#103B5D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1924,
    y: 22.1924,
    width: 39.6154,
    height: 24.8462,
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2307,
    cy: 27.2307,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2307,
    cy: 34.6154,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2307,
    cy: 41.9999,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6154,
    cy: 27.2307,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6154,
    cy: 34.6154,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6154,
    cy: 41.9999,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.9999,
    cy: 27.2307,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.9999,
    cy: 34.6154,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.9999,
    cy: 41.9999,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.3847,
    cy: 27.2307,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.3847,
    cy: 34.6154,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.3847,
    cy: 41.9999,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.7692,
    cy: 27.2307,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.7692,
    cy: 34.6154,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.7692,
    cy: 41.9999,
    r: 2.26923,
    fill: "white",
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6538 50.8076H41.3461V57.4999H38.6538V50.8076Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 57.5,
    width: 5,
    height: 15,
    fill: "#103B5D",
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLights);
export default __webpack_public_path__ + "static/media/Lights.67033b195bb3a134019428a3eeb2df80.svg";
export { ForwardRef as ReactComponent };